class MessageBag {
  /**
   * Create an instance of the class
   */
  constructor () {
    this.bag = {};
  }

  /**
   * Determine if the message bag has the given key
   *
   * @param  {String} key
   * @return {Boolean}
   */
  has (key) {
    return this.bag.hasOwnProperty(key);
  }

  /**
   * Get the message associated with the given key
   *
   * @param {String}
   */
  get (key) {
    return this.bag[key];
  }

  /**
   * Get the message associated with the given key. If the associated message
   * is an array, get the first message from that array.
   *
   * @param {String} key
   */
  first (key) {
    if (!this.has(key)) {
      return;
    }

    const item = this.bag[key];

    if (Array.isArray(item)) {
      return item[0];
    }

    return item;
  }

  /**
   * Put a message with the given key into the bag
   *
   * @param {String} key
   * @param {mixed} value
   */
  put (key, value) {
    this.bag[key] = value;
  }

  /**
   * Remove a message from the bag with the given key
   *
   * @param {String}
   */
  remove (key) {
    delete this.bag[key];
  }

  /**
   * Fill the message bag with the given messages
   *
   * @param {Object} messages
   */
  fill (messages) {
    this.bag = messages;
  }

  /**
     * Empty the message bag
     */
  empty () {
    this.bag = {};
  }
}

module.exports = MessageBag;
